export default __webpack_public_path__ + "static/media/cuet.ee5fe1d0.png";